module.exports = __webpack_public_path__ + "img/img-event.a7b0cd77.jpg";